import { RegistryComponent } from '@cian/mf-registry/browser/registryComponent';

export const RESET_FILTERS = '/v1/reset-filters';

export interface IChatbotFiltersApi {
  [RESET_FILTERS](): void;
}

export interface IChatbotFilters extends RegistryComponent {
  api: IChatbotFiltersApi;
}
